import React from "react";
import { Button } from "reactstrap";
import "./ButtonSecondary.scss";

const ButtonSecondary = ({ content, icon, className, onClick }) => {
  return (
    <Button
      color="dark"
      className={`${className} secondary_button `}
      onClick={onClick}
    >
      {content}
      <span className="ms-2"> {icon}</span>
      {/* {icon ? <img loading="lazy"src={icon} alt="Icon" className="ms-3 icon" /> : null} */}
    </Button>
  );
};

export default ButtonSecondary;
